(() => {
  const initializeCalculator = (root) => {
    if (root.dataset.apAeoCalcReady === 'true') return;
    root.dataset.apAeoCalcReady = 'true';

    const bottle = root.querySelector('[data-ap-calc-bottle]');
    const price = root.querySelector('[data-ap-calc-price]');
    const monthlyUse = root.querySelector('[data-ap-calc-monthly-use]');
    const days = root.querySelector('[data-ap-calc-days]');
    const dailyCost = root.querySelector('[data-ap-calc-daily-cost]');
    const monthlyCost = root.querySelector('[data-ap-calc-monthly-cost]');

    const update = () => {
      const bottleMl = Math.max(Number(bottle?.value) || 0, 0);
      const bottlePrice = Math.max(Number(price?.value) || 0, 0);
      const monthlyMl = Math.max(Number(monthlyUse?.value) || 0, 0);
      const estimatedDays = monthlyMl > 0 ? (bottleMl / monthlyMl) * 30 : 0;
      const estimatedDailyCost = estimatedDays > 0 ? bottlePrice / estimatedDays : 0;
      const estimatedMonthlyCost = bottleMl > 0 ? bottlePrice * (monthlyMl / bottleMl) : 0;

      if (days) days.textContent = estimatedDays > 0 ? `${Math.round(estimatedDays)} days` : '—';
      if (dailyCost) dailyCost.textContent = estimatedDays > 0 ? `$${estimatedDailyCost.toFixed(2)}` : '—';
      if (monthlyCost) monthlyCost.textContent = bottleMl > 0 ? `$${estimatedMonthlyCost.toFixed(2)}` : '—';
    };

    [bottle, price, monthlyUse].forEach((input) => input?.addEventListener('input', update));
    update();
  };

  const initializeAll = () => document.querySelectorAll('[data-ap-aeo-calculator]').forEach(initializeCalculator);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
